<template>
  <div class="nylon-CampaignInfo" :class="{ expired: product.isPreOrder && product.isExpired }">
    <div class="stats" v-if="product.isPreOrder">
      <div class="wrapper">
        <figure class="time" v-if="product.isLive">
          <NylonMeter :product="product" measureBy="time">
            <div class="text">
              <span class="number">{{ product.stats.timeLeft.value }}</span>
              <span class="caption" :class="{ ending: product.isEndingSoon }">
                <span>
                  <em class="interval">{{ product.stats.timeLeft.unit }}</em>
                  Left
                </span>
              </span>
              <NylonIcon icon-name="clock-stroke" class="icon" :class="{ ending: product.isEndingSoon }" />
            </div>
          </NylonMeter>
        </figure>
        <figure class="sales" v-if="product.isLive">
          <NylonMeter :product="product">
            <template v-if="product.isSalesVisible">
              <div class="text">
                <span class="number">{{ product.stats.sold }}</span>
                <span class="caption">
                  <span>
                    Sold
                    <em class="goal" v-if="showGoal">/ {{ product.stats.goal }} Goal</em>
                  </span>
                </span>
                <NylonIcon icon-name="graph-stroke" class="icon" />
              </div>
            </template>
            <template v-else>
              <div class="text" v-if="product.stats.sold < product.stats.goal">
                <span class="redacted">
                  <NylonIcon icon-name="tagNew" class="icon" style="width: 28px; height: 28px" />
                </span>
                <span class="caption">
                  <span>More Sales Needed</span>
                </span>
                <NylonIcon icon-name="graph-stroke" class="icon" />
              </div>
              <div class="text" v-else>
                <span class="redacted">
                  <NylonIcon icon-name="hi5-hand" class="icon" style="width: 24px; height: 24px" />
                </span>
                <span class="caption">
                  <span> Goal Met </span>
                </span>
                <NylonIcon icon-name="graph-stroke" class="icon" />
              </div>
            </template>
          </NylonMeter>
        </figure>
        <figure class="sales" v-else-if="product.isExpired && product.isSalesVisible">
          <NylonMeter :product="product">
            <div class="text">
              <span class="number">{{ product.stats.lifetimeSold }}</span>
              <span class="caption">
                <span>
                  Sold
                  <span class="u-hide-sm u-hide-md">All-Time</span>
                </span>
              </span>
              <NylonIcon icon-name="graph-stroke" class="icon" />
            </div>
          </NylonMeter>
        </figure>
        <figure class="requests" v-if="product.isExpired">
          <div class="text">
            <span class="number">{{ product.stats.requests }}</span>
            <span class="caption">
              <span>Requests</span>
            </span>
            <div class="icon">
              <NylonIcon icon-name="request-stroke" class="icon" />
            </div>
          </div>
        </figure>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
// Not async: the stats sit above the fold, and an empty meter would shift the page when it loaded.
import NylonMeter from "@/nylon/components/NylonMeter.vue";

export default {
  components: {
    NylonMeter,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },

    showGoal: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
